module.exports = __webpack_public_path__ + "img/banner1.e115175.jpg";